import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Label, TextInput, Button } from "flowbite-react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import traditionalFlower from "../../assets/traditionalPatternleft.png";
import logo from "../../assets/Mobile logo 1 - XL (1).png";
import { useNavigate } from "react-router-dom";
import * as urls from "../../api/urlHelper.js";
import * as func from "../../api/apiHelper.js";
import { toast } from "react-toastify";
import { AppContext } from "../context/appContext.js";
import { useContext } from "react";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const[showSigninButton,setShowSigninButton]= useState(true)
  const navigate = useNavigate();
  const {reloadContext,setReloadContext}= useContext(AppContext)

  useEffect(() => {
    const accessToken = func.getAccessToken();
    if (accessToken) {
      navigate("/dashboard");
      toast.warn("User Already Logged In successfully");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setShowSigninButton(false)
      const apiBody = { ...values, emailId: values.email.toLowerCase() };
      const loginApiResponse = await func.post(urls.STAFF_LOGIN_URL, apiBody);
      console.log(loginApiResponse,"this is login api response")
      if (
        loginApiResponse.status === 200 
      ) {
        func.setAccessToken(loginApiResponse?.data?.token);
        localStorage.setItem(
          "UD",
          JSON.stringify(loginApiResponse?.data?.staff)
        );
        toast.success("You are Logged in successfully!");
        setReloadContext(!reloadContext)
        navigate("/dashboard");
      } else {
        toast.warn(loginApiResponse);
      }
      setShowSigninButton(true)
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-[#19224B]">
      {/* Top right image */}
      <img
        src={traditionalFlower}
        alt="Traditional Flower Top Right"
        className="absolute top-0 right-0 w-1/4"
        style={{ transform: "rotate(180deg)" }}
      />

      <div
        className="w-full max-w-md p-8  rounded-lg shadow-lg"
        style={{ backgroundColor: "#E5E9F2" }}
      >
        <div className="flex justify-center mb-1 ">
          <img
            src={logo}
            alt="Brand Logo"
            className="h-14"
            style={{ height: "50px" }}
          />
        </div>
        <h6
          className=" font-bold text-center text-[#19224B] m-0"
          style={{ margin: "0px" }}
        >
          Admin Panel
        </h6>
        <h6
          className=" font-semibold text-center text-[#19224B] m-0"
          style={{ margin: "0px" }}
        >
          Welcome! Please log in to continue.
        </h6>

        <form onSubmit={formik.handleSubmit} className="mt-6">
          <div>
            <Label htmlFor="email" className="mb-2 block text-start">
              Email
            </Label>
            <TextInput
              id="email"
              name="email"
              type="email"
              placeholder="admin@matchmatrix.com"
              value={formik.values.email}
              onChange={formik.handleChange}
              onInput={(e)=>e.target.value = e.target.value.slice(0,40)}
              required
              style={{
                borderColor: "#D4A84D",
                boxShadow: "none",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#FCE29B")} // Change border color on focus
              onBlur={(e) => (e.target.style.borderColor = "#D4A84D")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="text-red-600" style={{ fontSize: "0.875rem" }}>
                {formik.errors.email}
              </div>
            ) : null}
          </div>

          <div className="mt-4">
            <Label htmlFor="password" className="mb-2 block text-start">
              Password
            </Label>
            <div className="relative">
              <TextInput
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder= {showPassword? "Qxxxxx@123":"••••••••"}
                onInput={(e)=>e.target.value = e.target.value.slice(0,40)}

                value={formik.values.password}
                onChange={formik.handleChange}
                required
                style={{
                  borderColor: "#D4A84D", // Border color
                  boxShadow: "none", // Remove default shadow
                }}
                onFocus={(e) => (e.target.style.borderColor = "#FCE29B")} // Change border color on focus
                onBlur={(e) => (e.target.style.borderColor = "#D4A84D")}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {showPassword ? (
                  <FaEyeSlash color="#D4A84D" />
                ) : (
                  <FaEye color="#D4A84D" />
                )}{" "}
                {/* Eye icon toggle */}
              </button>
            </div>
            {formik.touched.password && formik.errors.password ? (
              <div className="text-red-600" style={{ fontSize: "0.875rem" }}>
                {formik.errors.password}
              </div>
            ) : null}

            <p
              className="text-sm mt-3 cursor-pointer hover:text-blue-500 hover:underline"
              onClick={() => navigate("/forgot-pwd")}
            >
              Forgot Password ?
            </p>
          </div>

          <Button
            type="submit"
            className="w-full mt-6 text-white"
            disabled={!showSigninButton}
            style={{
              background:
                "linear-gradient(278.53deg, #D4A84D 41.62%, #FCE29B 89.24%)",
              border: "none",
              borderRadius: "0.375rem",
              outline: "none",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#FCE29B";
              e.target.style.outline = "none";
            }}
          >
            Sign in
          </Button>
        </form>
      </div>

      {/* Bottom left image */}
      <img
        src={traditionalFlower}
        alt="Traditional Flower Bottom Left"
        className="absolute bottom-0 left-0 w-1/4"
      />
    </div>
  );
};

export default Login;
